import styled from "styled-components/macro";
import {Button, CloseButton} from "@chakra-ui/react";
import {useState} from "react";
import {useModal} from "../store";
import storage from "../utils/storage";
import Login from "./login";
import Signup from "./signup";
import {useBaseCommunity} from "../store/hooks";
import {isPseudoCommunity} from "../store/communites";
import {themecolors} from "../utils/themecolors";

const Inner = styled.div``;
const SignupButton = styled.div``;
const LoginButton = styled.div``;
const Heading = styled.div``;
const Description = styled.p``;
const Text = styled.div``;

const SignupPrompt = styled(({className, community, message}) => {

    const baseCommunity = useBaseCommunity();

    const [dismissed, setDismissed] = useState(() => storage.getItem("dismissedSignupPrompt"));
    const handleDismiss = () => {
        storage.setItem("dismissedSignupPrompt", true);
        setDismissed(true);
    }

    const modal = useModal();
    const handleSignup = () => {
        modal.open(Signup);
    };
    const handleLogin = () => {
        modal.open(Login);
    };
    return !dismissed && isPseudoCommunity(baseCommunity) && (
        <div className={className}>
            <Inner>
                <Text>
                    <Heading>
                        Create an account
                    </Heading>
                    <Description>
                        {message || `Join ${community} and other communities.`}
                    </Description>
                </Text>
                <Button variant='grey' mr='6px' onClick={handleLogin}>Login</Button>
                <Button variant='blue' onClick={handleSignup}>Sign Up</Button>
                <CloseButton style={{marginLeft: 12, width: 48, height: 48}} onClick={handleDismiss}/>
            </Inner>
        </div>
    );
})`
  position: fixed;
  overflow: hidden;
  bottom: 0;
  width: 100%; 
  z-index: 2;
  height: 72px;
  color: ${({theme}) => theme.color.name === 'dark' ? '#fff' : themecolors.light_high_impact_text};
  font-weight: 500;
  background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_2 : '#fff'};
  
  ${Inner} {
    max-width: 1360px;
    padding: 0 24px;
    margin: 0 auto;
    display: flex;
    height: 72px;
    align-items: center;
  }

  ${Text} {
    display: flex;
    flex-direction: column;
    line-height: 20px;
    flex-grow: 1;
  }
  ${Heading} {
    font-weight: 500;
    font-size: 20px;
  }
  ${Description} {
    font-size: 15px;
    font-weight: 400;
  }
  
  ${LoginButton} {
    cursor: pointer;
    margin-left: auto;
    padding: 12px;
    margin-right: 12px;
  }

  ${SignupButton} {
    cursor: pointer;
    padding: 8px 16px;
    background-color: ${({theme}) => theme.color.name === 'dark' ? '#307ad5' : '#fff'};
    border-radius: 36px;
    color: ${({theme}) => theme.color.name === 'dark' ? '#fff' : 'rgb(64 64 64)'};
  }

  @media only screen and (max-width: 781px) {
    display: none;
  }
`;

export default SignupPrompt;
